function Final() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-900 via-black to-green-800 text-white flex items-center justify-center px-4">
      <section className="flex flex-col items-center space-y-4 text-center max-w-xl w-full">
        {/* ✅ دائرة فيها علامة صح */}
        <div className="bg-green-500 rounded-full p-4 shadow-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0,0,256,256"
          >
            <defs>
              <linearGradient
                x1="7.482"
                y1="4.982"
                x2="16.518"
                y2="14.018"
                gradientUnits="userSpaceOnUse"
                id="color-1"
              >
                <stop offset="0" stopColor="#ffffff"></stop>
                <stop offset="1" stopColor="#ffffff"></stop>
              </linearGradient>
            </defs>
            <g transform="scale(10.66667,10.66667)">
              <path
                d="M22.268,4.732c-0.976,-0.976 -2.559,-0.976 -3.536,0l-9.732,9.732l-3.732,-3.732c-0.976,-0.976 -2.559,-0.976 -3.536,0c-0.977,0.976 -0.976,2.559 0,3.536l4.645,4.645c1.449,1.449 3.797,1.449 5.246,0l10.645,-10.645c0.976,-0.977 0.976,-2.56 0,-3.536z"
                fill="url(#color-1)"
              ></path>
            </g>
          </svg>
        </div>

        {/* ✅ رسالة التأكيد */}
        <h2 className="text-2xl font-bold text-green-300">
          تم إرسال بياناتك بنجاح!
        </h2>
        <p className="text-lg text-gray-200">
          سيقوم أحد ممثلي خدمة العملاء بالتواصل معك قريبًا لتأكيد الطلب.
        </p>

        {/* ✅ صورة المنتج */}
        <img
          alt="علبة جل موفكس واقفة بزاوية أمامية"
          src="/product.webp"
          className="w-60 h-72 pb-6 object-contain"
        />

        {/* ✅ زر الرجوع */}
        <a
          href="/"
          className="mt-4 px-6 py-3 bg-green-500 text-white font-semibold rounded-full hover:bg-green-600 transition duration-300"
        >
          الرجوع إلى الصفحة الرئيسية
        </a>
      </section>
    </div>
  );
}

export default Final;
